<!-- 设备设施台账 -->
<template>
   <div class='page_content'>
      <subComponents ref="showSelectData"></subComponents>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch">

            </v-search>
         </div>
      </div>
      <div class="page_content_center">
         <el-table v-if="pageShowData.jurTableVo" @selection-change="handleSelectionChange" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%"
                   highlight-current-row size="mini">
            <el-table-column type="selection" width="40"></el-table-column>
            <el-table-column align="center" v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :prop="tableValye.entityField"
                             :min-width="tableValye.fieldWeight" :label="tableValye.showField">
               <template slot="header">
                  <div>
                     <el-tooltip :content="tableValye.showField" placement="top">
                        <div class="long_title"><span :ref="tableValye.entityField">{{ tableValye.showField
                                }}</span></div>
                     </el-tooltip>
                  </div>
               </template>
               <template slot-scope="scope">
                  <el-tag size="mini" v-if="tableValye.entityField == 'isWms'">
                     {{ scope.row.isWms == 0 ? '否' : '是' }}
                  </el-tag>
                  <el-tag size="mini" v-else-if="tableValye.entityField == 'psomState'">
                     {{ $common.getIsGsp(tableValye.formatterContent, scope.row.psomState) }}</el-tag>
                  <span v-else-if="tableValye.entityField == 'emaRegdate'">
                     <span v-if="scope.row[tableValye.entityField]">
                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                     </span>
                  </span>

                  <span v-else-if="tableValye.entityField == 'regDate'">
                     {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                  </span>
                  <span v-else-if="tableValye.fieldType == 'date'">
                     {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                  </span>
                  <span v-else-if="tableValye.entityField == 'emaCreatetime'">
                     <span v-if="scope.row[tableValye.entityField]">
                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                     </span>
                  </span>
                  <!-- <span v-else-if="tableValye.entityField == 'psomId'">
                        <a @click="toDetail(scope.row)">{{scope.row[tableValye.entityField]}}</a>
                    </span> -->
                  <span v-else-if="tableValye.entityField == 'stId'">{{
                            getStName(scope.row[tableValye.entityField]) }}</span>
                  <span v-else-if="tableValye.entityField == 'attachFile'">
                     <ul class="upload_ul">
                        <li v-for="(val, key) in scope.row.attachFile.split(',')" :key="key">
                           <cusImage style="width: 20px; height: 20px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                           </cusImage>
                        </li>
                     </ul>
                  </span>
                  <span v-else>
                     {{ scope.row[tableValye.entityField] }}
                  </span>
               </template>
            </el-table-column>
         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <el-drawer :close-on-press-escape="true" :title="diaType == 0 ? '新增' : '修改'" :visible.sync="dialogAdd" :with-header="false" :append-to-body="true" :direction="'ltr'" size="50%">
         <div class="demo-drawer__content data_action_form">
            <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
               <v-tabs :type="diaType" :activeName="diaType == 0 ? '新增设备设施台账' : '修改设备设施台账'" :name="'jciName'" :value="'jciName'" :tabslist="formDataList.jurconfigform" @tabs="(val) => { showTabs = val }">
                  <template slot="tabs" slot-scope="scope">
                     <div class="table_content_box">
                        <!-- 主信息 -->
                        <div v-if="scope.index == 0">
                           <el-form :model="sendDataInfo" id="mainInfo" class="baseForm" label-width="120px" ref="sendDataInfo" :show-message="false">
                              <el-row>
                                 <el-form-item v-if="formOneValue.isShow == 1" v-for="(formOneValue, formOneKey) in formDataList.jurconfigform" :key="formOneKey" :label="formOneValue.showField"
                                               :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                    <el-date-picker v-if="formOneValue.fieldType == 'date'" size="mini" v-model="sendDataInfo[formOneValue.entityField]" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date"
                                                    placeholder="选择日期"></el-date-picker>
                                    <!-- 设备名称 -->
                                    <el-input v-else-if="formOneValue.entityField == 'fmName'" @focus="openSearch(formOneValue.searchId, 0, 'fmName')" v-model="sendDataInfo[formOneValue.entityField]" clearable>
                                       <el-button @click="openSearch(formOneValue.searchId, 0, 'fmName')" slot="append" icon="el-icon-search"></el-button>
                                    </el-input>
                                    <!-- 登记人 -->
                                    <el-input v-else-if="formOneValue.entityField == 'emaPerson'" @focus="openSearch(formOneValue.searchId, 0, 'emaPerson')" v-model="sendDataInfo[formOneValue.entityField]" clearable>
                                       <el-button @click="openSearch(formOneValue.searchId, 0, 'emaPerson')" slot="append" icon="el-icon-search"></el-button>
                                    </el-input>
                                    <!-- 库房 -->
                                    <el-select v-else-if="formOneValue.entityField == 'stId'" v-model="sendDataInfo[formOneValue.entityField]">
                                       <el-option v-for="(storageRoomValue, storageRoomKey) in storageRoomList" :key="storageRoomKey" :label="storageRoomValue.stName" :value="storageRoomValue.stId">
                                       </el-option>
                                    </el-select>
                                    <el-upload v-else-if="formOneValue.entityField == 'attachFile'" class="upload-demo" :action="requesUrl + '/upload/fileupload'" :headers="token" :multiple="true"
                                               :on-success="fileUpload" :before-remove="beforeRemove" :before-upload="beforeUpload" :file-list="fileList" list-type="picture">
                                       <el-button size="small" type="primary">点击上传</el-button>
                                       <!-- <div slot="tip" class="el-upload__tip">不超过500kb</div> -->
                                    </el-upload>
                                    <el-input v-else-if="formOneValue.entityField == 'emaRemaark'" type="textarea" v-model="sendDataInfo[formOneValue.entityField]" clearable></el-input>
                                    <el-input v-else v-model="sendDataInfo[formOneValue.entityField]" clearable></el-input>
                                 </el-form-item>
                              </el-row>
                           </el-form>
                        </div>
                     </div>
                  </template>
               </v-tabs>
            </el-card>
            <div class="foots">
               <el-button @click="dialogAdd = false">取 消</el-button>
               <el-button type="primary" @click="diaConfirm">确 定</el-button>
            </div>
         </div>
      </el-drawer>
      <printPlan ref="printPlan"></printPlan>
      <!-- 自定义设计 -->
      <customDesign ref="customDesign"></customDesign>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import ExtractionScheme from "../../../byComponents/ExtractionScheme.vue";
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      ExtractionScheme
   },
   data() {
      //这里存放数据
      return {
         imgUrl: window.global_config.BASE_IMG_URL,
         tableHeight: 0,
         getRequestData: {
            page: 1,
            rows: 30,
            start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000,
            end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1,
            emaPerson: ''
         },
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: []
         },
         sendDataInfo: {
            "emaCreater": 0,
            "emaCreatetime": 0,
            "emaId": 0,
            "emaPerson": "",
            "emaRegdate": 0,
            "emaRemaark": "",
            "fmId": 0,
            "fmName": '',
            "fmNum": 0,
            "inRate": 0,
            "money": 0,
            "price": 0,
            "psmoney": 0,
            "psprice": 0,
            "stId": 0,
            attachFile: [],
            dumAnnex: '',
         },
         dialogAdd: false,
         buttonList: [],
         pageShowData: [],
         formDataList: [],
         multipleSelection: [],
         exId: "",
         seId: "",
         ceshi: "",
         dialogTitle: "",
         seWidth: "",
         height: "",
         exTitle: "",
         seTitle: "",
         seWidth: "",
         exWidth: "",
         DialogVisible: false,
         DialogExtract: false,
         seType: '',
         smId: '',
         diaType: 0,
         wayList: [],
         parentSearchData: {},
         storageRoomList: [],
         requesUrl: "",
         token: {
            token: sessionStorage.getItem("token"),
         },
         fileList: [],
         attachFile: [],
         srcList: [],
         imgUrl: ''
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      'getRequestData.fmName': {
         handler: function (newValue, oldValue) {
            if (newValue == '') {
               this.getRequestData.fmId = ''
            }
         },
         deep: true,
      },
      'sendDataInfo.fmNum': {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.money = this.$common.getDecimalInfo(3, (newValue * this.sendDataInfo.price))
            // this.sendDataInfo.money = (newValue * this.sendDataInfo.price).toFixed(2)
         },
      },
      'sendDataInfo.price': {
         handler: function (newValue, oldValue) {
            this.sendDataInfo.money = this.$common.getDecimalInfo(3, (newValue * this.sendDataInfo.fmNum))
            // this.sendDataInfo.money = (newValue * this.sendDataInfo.fmNum).toFixed(2)

         },
      },

   },
   //方法集合
   methods: {
      handleSelectionChange(val) {
         this.multipleSelection = val;
      },
      async fileUpload(event) {
         if (event.status == 200) {
            event.result.forEach((item) => {
               console.log(item, 'item333');
               console.log(this.sendDataInfo.attachFile, 'item333');

               this.sendDataInfo.attachFile.push(item.fileUrl)
            })
         } else {
            this.$message({
               type: 'error',
               message: event.messsage
            });
         }

      },
      beforeUpload(file) {
         for (let i = 0; i < this.sendDataInfo.attachFile.length; i++) {
            const v = this.sendDataInfo.attachFile[i]
            if (v.fileName == file.name) {
               this.$message({
                  type: "error",
                  message: "请勿重复添加",
               })
               return false
            }
         }
         console.log(file, this.sendDataInfo.attachFile);
      },
      beforeRemove(file, fileList) {
         console.log(file, fileList)
         let index = 0
         for (let i = 0; i < fileList.length; i++) {
            const item = fileList[i];
            if (item == file.fileUrl) {
               index = i
               break
            }
         }
         this.sendDataInfo.attachFile.splice(index, 1)
      },
      imgur() {
         this.requesUrl = this.$store.getters.getConfig.requestUrl;
         this.imgUrl = this.$store.getters.getConfig.imgUrl;
      },
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1;
            this.getRequestData.end = time;
         }
      },
      toDetail(row) { },
      changeInputModel(val) {
         console.log(val);
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            if (this.seType == 'fmId') {
               this.getRequestData.fmName = val.fmName
               this.getRequestData.fmId = val.fmId
            } else if (this.seType == 'fmName') {
               for (let key in val) {
                  this.sendDataInfo[key] = val[key]
               }
            } else if (this.seType == 'emaPerson') {
               this.sendDataInfo.emaPerson = val.opmName
            } else if (this.seType == 'emaPersonSearch') {
               this.getRequestData.emaPerson = val.opmName
            }
         }
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },
      getWidth(e) {
         console.log(e);
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      getExtractName(e) {
         console.log(e);
         this.exTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      openSearch(sId, index, type) {
         this.seType = type
         this.DialogVisible = true
         this.seId = sId
         if (type == 'emaPerson') {
            this.parentSearchData = {
               opmBuyer: ''
            }
         }
      },
      isShowData(name, value) {
         switch (name) {
            case 'supplier':
               var dataInfo = sessionStorage.getItem('selectSupplierData')
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo)
                  this.getRequestData.psomBuycus = dataInfo.smId
                  this.getRequestData.smName = dataInfo.smName
               }
               break;
         }
      },
      // 获取数据列表
      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path)
         let responseData = await this.$http.getJur({
            ids: [pathId.jurId]
         })
         if (responseData.status == 200) {
            this.getButtonList()
            this.pageShowData = responseData.result
            this.formDataList = this.pageShowData.jurFormVoList[0]
            if (this.formDataList.jurconfigform[0].chineseField == "设备ID") {
               this.formDataList.jurconfigform.splice(0, 1)
            }
            var obj = {}
            if (this.pageShowData.jurHead) {
               obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
            } else {
               obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
            }
            for (const key in obj) {
               this.$set(this.getRequestData, key, obj[key])
            }
            this.getDataList()
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      init() {
         for (let key in this.sendDataInfo) {
            if (key == 'emcMeasures') this.sendDataInfo[key] = []
            else this.sendDataInfo[key] = ''
         }
         this.sendDataInfo.attachFile = [];
         this.sendDataInfo.dumAnnex = '';
         this.attachFile = []
         this.fileList = []
      },
      async sub() {
         let sendData = JSON.parse(JSON.stringify(this.sendDataInfo));
         sendData.attachFile = sendData.attachFile.toString()
         if (this.diaType == 0) {
            var responseData = await this.$http.addGspTzInfo(sendData)
         } else {
            var responseData = await this.$http.updateGspYhInfo(sendData)
         }
         if (responseData.status == 200) {
            this.$message({
               message: '操作成功',
               type: 'success'
            });
            this.dialogAdd = false
            this.getDataList()

         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      diaConfirm(sendDataInfo) {
         this.$refs['sendDataInfo'].validate((valid) => {
            if (valid) {
               this.sub()
            } else {
               console.log('error submit!!');
               return false;
            }
         });
      },
      openAddDia(e) {
         console.log(e, 'e333');

         if (e == 0) {
            this.diaType = 0
            this.init()
         } else {
            this.diaType = 1
            if (this.multipleSelection.length != 1) {
               return this.$message.error("请勾选一条数据操作")
            }
            var dataInfo = this.multipleSelection[0]
            for (let key in dataInfo) {
               this.sendDataInfo[key] = dataInfo[key]
            }
         }
         this.dialogAdd = true
      },
      // 动作集合
      actionSet(actionData) {
         console.log(actionData.actionType, 'actionData.actionType');
         switch (actionData.actionType) {
            case 0:
               this.openAddDia(0)
               // this.$refs['emcuringListAction'].openBox(0,this.formDataList,'','')
               break;
            case 1:

               this.openAddDia(1)
               // this.$refs['emcuringListAction'].openBox(1,this.formDataList,'',dataInfo)
               break;
            case 2:
               this.delDataAction()
               break;
            case 3:
               this.submitDataAction()
               break;
            case 88:
               this.showPrintPlan()
               break
            case 15:
               this.openFormDesign()
               break;

         }
      },

      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path)
         this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
      },
      showPrintPlan() {
         if (this.multipleSelection.length <= 0) {
            return this.$message.error("请勾选数据操作")
         }
         var list = this.multipleSelection.map(item => item.emaId)
         // 调用全局方法 判断Websocket是否连接
         if (this.$printSocketApi.printExeMsg() != false) {
            // 选中的数据
            this.$refs.printPlan.openDia(list, sessionStorage.getItem('printSource').replace(/\"/g, ""), sessionStorage.getItem('printJurId'), "", "all")
         } else {
            return
         }
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1
         this.getDataList()
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val
         this.getDataList()
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1
         this.getRequestData.rows = val
         this.getDataList()
      },

      // 获取数据列表
      async getDataList() {
         let responseData = await this.$http.getGspTzList(this.getRequestData)
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list
            this.returnData.pages = responseData.result.pages
            this.returnData.total = responseData.result.total
            this.returnData.pageNum = responseData.result.pageNum
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      // 删除数据
      delDataAction() {
         if (this.multipleSelection.length != 1) {
            return this.$message.error("请勾选一条数据操作")
         }
         var dataInfo = this.multipleSelection[0]

         this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(async () => {
            var delData = {
               ids: [dataInfo.emaId, dataInfo.fmId]
            }
            let responseData = await this.$http.delGspTzInfo(delData)
            if (responseData.status == 200) {
               this.$message({
                  type: 'success',
                  message: '删除成功!'
               });

               this.getDataList()
            } else {
               this.$message({
                  message: responseData.message,
                  type: 'error'
               });
            }

         }).catch(() => { });
      },

      // 提交审核
      submitDataAction() {
         if (this.multipleSelection.length != 1) {
            return this.$message.error("请勾选一条数据操作")
         }
         var dataInfo = this.multipleSelection[0]

         this.$confirm('确定要提交审核?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
         }).then(async () => {
            var delData = {
               ids: [dataInfo.psomId]
            }
            let responseData = await this.$http.submitPurchaseOrder(delData)
            if (responseData.status == 200) {
               this.$message({
                  type: 'success',
                  message: '操作成功'
               });

               this.getDataList()
            } else {
               this.$message({
                  message: responseData.message,
                  type: 'error'
               });
            }

         }).catch(() => { });
      },
      //  查看图片
      lookImg(row) {
         console.log(row)
         this.srcList = []
         var arr = row.fileUrl.split(',')
         arr.forEach(item => {
            this.srcList.push(this.imgUrl + '/' + item)
         })
      },
      //获取状态
      getIsGsp(str, val) {
         try {
            str && str.replace(/\\/g, '')
            let arr = JSON.parse(str)
            let len = arr.length
            let newStr = ''
            for (let i = 0; i < len; i++) {
               if (arr[i].key === val) {
                  newStr = arr[i].value
                  break;
               }
            }
            return newStr
         } catch (ex) {
            return str
         }
      },

      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
         
      },
// 获取国家
      async getWay() {
         let responseData = await this.$http.getPartDictionariesData({
            ids: [19]
         })
         if (responseData.status == 200) {
            if (responseData.result.yhcs) {
               this.wayList = responseData.result.yhcs
            }
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      // 获取所有可用库房列表
      async getAllStorageRoom() {
         let responseData = await this.$http.getAllStorageRoom()
         if (responseData.status == 200) {
            this.storageRoomList = responseData.result
         } else {
            this.$message({
               message: responseData.message,
               type: 'error'
            });
         }
      },
      getStName(id) {
         var name = ''
         this.storageRoomList.forEach(item => {
            if (item.stId == id) {
               name = item.stName
               // return item.stName
            }
         })
         return name
      }

   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.imgur();
      this.getPageInfo()
      this.getWay()
      this.getAllStorageRoom()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {

   },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}

.el-drawer {
   outline: none;
}

.el-row {
   display: flex;
   flex-wrap: wrap;
}

.upload_ul {
   width: 280px;
   list-style: none;
   display: flex;
   align-items: center;
   flex-wrap: wrap;
}
.upload_ul li {
   position: relative;
   width: 22px;
   height: 22px;
   margin-right: 3px;
   margin-bottom: 3px;
   border: 1px solid #dedede;
}
.upload_ul li .del {
   display: none;
   position: absolute;
   top: -1px;
   right: -1px;
   font-size: 10px;
   z-index: 99;
   cursor: pointer;
}
.upload_ul li .del:hover {
   color: #409eff;
}
.upload_ul li:hover .del {
   display: inline-block;
}
.upload_ul li ::v-deep .el-image__error {
   font-size: 5px;
}
.upload_ul li ::v-deep .cus-image {
   width: 20px !important;
   height: 20px !important;
}
.upload_ul li ::v-deep .cus-image img {
   width: 20px !important;
   height: 20px !important;
}
</style>